<div class="sx-filter">
  <div class="sx-filter-dialog__scroll-area">
      <div class="sx-filter__header">
        <div class="sx-filter__header__title">
          Filtrera
        </div>
    
        <button class="sx-filter__header__close sx-button sx-button--white sx-button--exit" mat-button (click)="onClose()">
          <svg>
            <use xlink:href="#baseline-close-24px" href="#baseline-close-24px" />
          </svg>
        </button>
      </div>
    <div class="sx-filter__content">
      <!-- Lista filter-definitions -->
       @for(definition of filterDefinitions; track filterDefinitions; let i = $index;){
        <article id="filter_definition_{{i}}">
          <app-filter-wrapper [filter]='definition' (valueChanged)="onFilterChanged($event)">
          </app-filter-wrapper>
        </article>
       }
    </div>
  </div>
  <div class="sxh-button-footer sxl-align-right sxl-horizontal-stack-small sx-filter__button-footer">
    <button class="sx-button sx-button--white" mat-button (click)="clearFilter()">{{'core.filter.clear-filter'|translate}}</button>
    <button class="sx-button sx-button--magenta" mat-button (click)="onFilter()">{{'core.filter.save-and-close'|translate}}</button>
  </div>
</div>